<template>
  <div>
    <v-tabs
      v-model="tab"
      align-with-title
    >
      <v-tabs-slider color="yellow"></v-tabs-slider>
      <v-tab href="#home-tab" to="/home-tab">
        <v-icon>
          mdi-notebook-outline
        </v-icon>
      </v-tab>
      <v-tab href="#message-tab" to="/message-tab">
        <v-icon>
          mdi-message-text-outline
        </v-icon>
      </v-tab>
      <v-tab href="#profile-tab" to="/profile-tab">
        <v-icon>
          mdi-account-outline
        </v-icon>
      </v-tab>
      <v-tabs-items>
        <v-card flat>
<!--            <v-card-text >-->

            <div class="bg-img-avatar">
              <img :src="user_image" />
            </div>
          <div class="profile-card">
            <div class="profile-img">
              <img :src="user_image" />
            </div>
            <div class="profile-name-num">
              <div class="row">
                <div class="col-6 text-right black-text">
                  {{user_name}}
                </div>
                <div class="col-6 black-text" style="text-align: start">
                  <span class="num">
                     {{user_mobile}}
                  </span>
                </div>
              </div>
            </div>
            <div class="profile-action">
              <div class="width-50" v-on:click="goToContacts()">
                <v-icon>
                  mdi-account-box-outline
                </v-icon>
                <span>{{ $t('contacts') }}</span>
              </div>
              <div class="width-50" v-on:click="goToSavedMessage()">
                <v-icon>
                  mdi-android-messages
                </v-icon>
                <span>{{ $t('savedMessage') }}</span>
              </div>
              <div class="width-50" v-on:click="logout()">
                <v-icon>
                  mdi-exit-to-app
                </v-icon>
                <span>{{ $t('exit') }}</span>
              </div>
              <div class="width-50">
                <v-icon>
                  mdi-phone-message-outline
                </v-icon>

                <span>{{ $t('contactUs') }}</span>
              </div>
              <div class="width-50" v-on:click="change_post()">
                <v-icon>
                  mdi-exit-to-app
                </v-icon>
                <span>{{ $t('changeLoginPost') }}</span>
              </div>
              <div class="width-50" v-on:click="goToSetting()">
                <v-icon>
                  mdi-cog-outline
                </v-icon>
                <span>{{ $t('settings') }}</span>
              </div>
            </div>
          </div>
          <div class="text-center">
            {{branch_name}}
          </div>
          <div class="text-center"><label class="black-text">{{version}}</label></div>

<!--            </v-card-text>-->
        </v-card>
      </v-tabs-items>
    </v-tabs>
  </div>

</template>
<script>

  export default {
    data () {
      return {
        tab: null,
        branch_name:localStorage.getItem("branch_name"),

        user_name :'',
        user_mobile :'',
        user_image :'',
        version:process.env.VUE_APP_APP_VERSION,
      }
    },
    mounted () {
      var user_data = JSON.parse(localStorage.getItem('profile'))

      this.user_name = user_data.UserName
      this.user_image = user_data.ThumbPath
      this.user_mobile = localStorage.getItem('phone')
    },
    methods:{
      logout () {
        localStorage.setItem('profile', '')
        localStorage.setItem('phone', '')
        localStorage.setItem('password', '')
        localStorage.setItem('party_id', '')
        this.$router.push({ name:'login', params:{} })
      },
      change_post () {
        localStorage.setItem('party_id', '')
        this.$router.push({ name:'post_login', params:{} })
      },
      goToSetting () {
        this.$router.push({ name:this.$t('settings'), params:{} })
      },
      goToContacts () {
        this.$router.push({ path: '/contacts', params: {} })
      },
      goToSavedMessage () {
        // this.$router.push({path: '/saved-message', params: {}})
        var user_data = JSON.parse(localStorage.getItem('profile'))
        console.log('user_dat ', user_data)
        const last_chat_detail = {
          RecType: 0,
          UserOrGroupId : user_data.UserId
        }
        localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
        this.$router.push({ name: this.$t('conversations'), params: {} })
      }
    }
  }
</script>
